module.exports = __webpack_public_path__ + "img/ic-square-grid.a5165f0f.svg";